import React, { useRef } from 'react';
import { FaCheckCircle, FaBoxOpen, FaTruck, FaHandshake, FaPrint } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import OrderInvoice from './OrderInvoice';
import { useReactToPrint } from 'react-to-print';

const ReceivedComponent = ({ order }) => {
    const printRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <div className="max-w-2xl mx-auto">
            <div className="flex items-center justify-center h-full py-6">
                <div className="w-full p-8 text-center bg-white rounded-lg shadow-lg">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="relative">
                            <div className="flex items-center justify-center w-24 h-24 bg-green-100 rounded-full animate-pulse">
                                <FaCheckCircle className="w-16 h-16 text-green-500" />
                            </div>
                            <div className="absolute flex items-center justify-center w-10 h-10 bg-green-500 rounded-full -bottom-2 -right-2">
                                <MdVerified className="w-6 h-6 text-white" />
                            </div>
                        </div>
                    </div>

                    {/* Success Message */}
                    <h2 className="mb-4 text-2xl font-bold text-gray-800">Order Completed Successfully!</h2>

                    {/* Status Steps */}
                    <div className="mb-8 space-y-4">
                        <div className="flex items-center justify-center gap-3 text-gray-600">
                            <FaBoxOpen className="w-5 h-5 text-green-500" />
                            <span>Order has been received</span>
                        </div>
                        <div className="flex items-center justify-center gap-3 text-gray-600">
                            <FaTruck className="w-5 h-5 text-green-500" />
                            <span>Items have been delivered</span>
                        </div>
                        <div className="flex items-center justify-center gap-3 text-gray-600">
                            <FaHandshake className="w-5 h-5 text-green-500" />
                            <span>Transaction completed</span>
                        </div>
                    </div>

                    {/* Order Details */}
                    <div className="p-4 mb-6 rounded-lg bg-gray-50">
                        <p className="mb-2 text-sm text-gray-600">Order Summary:</p>
                        <div className="space-y-2 text-left">
                            <p className="text-xs"><span className="font-medium">Status:</span> <span className="font-medium text-green-500">Completed</span></p>
                            <p className="text-xs"><span className="font-medium">Date:</span> {new Date(order?.created_at).toLocaleDateString()}</p>
                        </div>
                    </div>

                    {/* Thank You Message */}
                    <div className="mb-6">
                        <p className="text-sm text-gray-600">Thank you for your business!</p>
                        <p className="mt-1 text-xs text-gray-500">Your order has been successfully completed and recorded.</p>
                    </div>

                    {/* Print Button */}
                    <div className="flex justify-center">
                        <button
                            onClick={handlePrint}
                            className="inline-flex items-center gap-2 px-6 py-2 text-white transition-colors duration-200 bg-green-500 rounded-md hover:bg-green-600"
                        >
                            <span>Print Invoice</span>
                            <FaPrint className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Hidden Invoice Component */}
            <div style={{ display: 'none' }}>
                <OrderInvoice
                    order={order}
                    ref={printRef}
                />
            </div>
        </div>
    );
}

export default ReceivedComponent;
